'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _dateTimeFormatter = require('../../utils/date-time-formatter');

var _dateUtils = require('../../utils/date-utils');

var _reduceToChunks = require('../../utils/reduce-to-chunks');

var _reduceToChunks2 = _interopRequireDefault(_reduceToChunks);

var _scrollToElement = require('../../utils/scroll-to-element');

var _scrollToElement2 = _interopRequireDefault(_scrollToElement);

var _button = require('../button/');

var _button2 = _interopRequireDefault(_button);

var _dialog = require('../dialog/');

var _dialog2 = _interopRequireDefault(_dialog);

var _iconButton = require('../icon-button/');

var _iconButton2 = _interopRequireDefault(_iconButton);

var _icon = require('../icon/');

var _icon2 = _interopRequireDefault(_icon);

var _input = require('../input/');

var _input2 = _interopRequireDefault(_input);

var _text = require('../text/');

var _text2 = _interopRequireDefault(_text);

var _title = require('../title/');

var _title2 = _interopRequireDefault(_title);

var _toolbar = require('../toolbar/');

var _toolbar2 = _interopRequireDefault(_toolbar);

var _constants = require('./constants');

require('./date-picker.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DatePicker = function (_React$Component) {
  _inherits(DatePicker, _React$Component);

  function DatePicker(props) {
    _classCallCheck(this, DatePicker);

    var _this = _possibleConstructorReturn(this, (DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).call(this, props));

    var currentDate = new Date();
    currentDate.setHours(0);
    currentDate.setMinutes(0);
    currentDate.setSeconds(0);

    _this.state = {
      defaultType: _constants.DAYS_CALENDAR,
      calendarType: _constants.DAYS_CALENDAR,

      currentDay: currentDate.getDate(),
      currentMonth: currentDate.getMonth(),
      currentYear: currentDate.getFullYear(),

      calendarMonth: currentDate.getMonth(),
      calendarYear: currentDate.getFullYear(),

      selectedDate: +currentDate,
      inputValue: '',

      isDatePickerVisible: false,
      triggerDialogClose: false
    };

    _this.handleStartNavigationClick = _this.handleStartNavigationClick.bind(_this);
    _this.handleEndNavigationClick = _this.handleEndNavigationClick.bind(_this);
    _this.handleDateChange = _this.handleDateChange.bind(_this);
    _this.handleDateSelection = _this.handleDateSelection.bind(_this);

    _this.openDatePicker = _this.openDatePicker.bind(_this);
    _this.closeDatePicker = _this.closeDatePicker.bind(_this);
    _this.resetSelectedDate = _this.resetSelectedDate.bind(_this);

    _this.renderDayEntity = _this.renderDayEntity.bind(_this);
    _this.renderMonthEntity = _this.renderMonthEntity.bind(_this);

    _this.renderDatePickerHeader = _this.renderDatePickerHeader.bind(_this);
    return _this;
  }

  _createClass(DatePicker, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          value = _props.value,
          disableDayPicker = _props.disableDayPicker;
      var selectedDate = this.state.selectedDate;


      if (value && selectedDate !== value) {
        this.setStateFromValue(value);
      }

      if (disableDayPicker) {
        this.setState({
          defaultType: _constants.MONTHS_CALENDAR,
          calendarType: _constants.MONTHS_CALENDAR
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var disableDayPicker = this.props.disableDayPicker;
      var selectedDate = this.state.selectedDate;


      if (nextProps.value && this.getUTCFormatterDate(selectedDate) !== nextProps.value) {
        this.setStateFromValue(nextProps.value);
      }

      if (nextProps.disableDayPicker !== disableDayPicker) {
        this.setState({
          defaultType: _constants.MONTHS_CALENDAR,
          calendarType: _constants.MONTHS_CALENDAR
        });
      }
    }
  }, {
    key: 'getUTCFormatterDate',
    value: function getUTCFormatterDate(selectedDate) {
      return Math.floor(selectedDate / 1000);
    }
  }, {
    key: 'setStateFromValue',
    value: function setStateFromValue(value) {
      var date = new Date(parseInt(value, 10) * 1000);

      if (typeof value === 'string') {
        this.setState({ inputValue: '' });
        this.resetSelectedDate();

        return;
      }

      this.setState({
        selectedDate: +date,
        calendarMonth: date.getMonth(),
        calendarYear: date.getFullYear(),
        inputValue: +date
      });
    }
  }, {
    key: 'getStartingWeekDayIndex',
    value: function getStartingWeekDayIndex() {
      var locales = this.props.locales;


      if (_constants.saturdayAsFirstDayOfWeekLocales.includes(locales)) {
        return 5;
      }

      if (_constants.sundayAsFirstDayOfWeekLocales.includes(locales)) {
        return 6;
      }

      return 0;
    }
  }, {
    key: 'getWeeksInMonth',
    value: function getWeeksInMonth() {
      var _this2 = this;

      var _state = this.state,
          calendarMonth = _state.calendarMonth,
          calendarYear = _state.calendarYear;


      return (0, _dateUtils.getDaysDatesInMonth)(calendarMonth, calendarYear).map(function (weekDay) {
        if (weekDay.getDay() === _this2.getStartingWeekDayIndex()) {
          return '' + weekDay + _constants.DAY_SPLITTER + _constants.WEEK_SPLITTER;
        }

        return '' + weekDay + _constants.DAY_SPLITTER;
      }).join('').split(_constants.WEEK_SPLITTER).filter(Boolean).map(function (week, index) {
        var weekDays = week.split(_constants.DAY_SPLITTER).filter(Boolean);
        var fullWeekArray = new Array(_constants.DAYS_IN_WEEK - weekDays.length);
        var isFirstWeekInMonth = index === 0;

        if (isFirstWeekInMonth) {
          return fullWeekArray.fill(null).concat(weekDays);
        }

        return weekDays.concat(fullWeekArray.fill(null));
      });
    }
  }, {
    key: 'getInputDateFromLocales',
    value: function getInputDateFromLocales() {
      var locales = this.props.locales;
      var inputValue = this.state.inputValue;


      return (0, _dateTimeFormatter.getDate)(inputValue, locales);
    }
  }, {
    key: 'getHeaderDateFromLocales',
    value: function getHeaderDateFromLocales() {
      var _props2 = this.props,
          locales = _props2.locales,
          hideDayInHeader = _props2.hideDayInHeader;

      var day = hideDayInHeader ? '' : this.getSelectedDay();
      var month = this.getSelectedMonth();
      var year = this.getSelectedYear();

      if (_constants.monthDayYearDateFormatLocales.includes(locales)) {
        // eslint-disable-next-line
        return (_constants.ABBREVIATED_MONTHS[month] + ' ' + day).trim() + (', ' + year);
      }

      return (day + ' ' + _constants.ABBREVIATED_MONTHS[month] + ' ' + year).trim();
    }
  }, {
    key: 'getSelectedDay',
    value: function getSelectedDay() {
      var selectedDate = this.state.selectedDate;


      return new Date(selectedDate).getDate();
    }
  }, {
    key: 'getSelectedMonth',
    value: function getSelectedMonth() {
      var selectedDate = this.state.selectedDate;


      return new Date(selectedDate).getMonth();
    }
  }, {
    key: 'getSelectedYear',
    value: function getSelectedYear() {
      var selectedDate = this.state.selectedDate;


      return new Date(selectedDate).getFullYear();
    }
  }, {
    key: 'closeDatePicker',
    value: function closeDatePicker() {
      this.setState({
        isDatePickerVisible: false,
        triggerDialogClose: false,
        calendarType: this.state.defaultType
      });
    }
  }, {
    key: 'openDatePicker',
    value: function openDatePicker() {
      if (this.props.disabled) {
        return;
      }

      this.setState({ isDatePickerVisible: true });
    }
  }, {
    key: 'handleStartNavigationClick',
    value: function handleStartNavigationClick() {
      var _state2 = this.state,
          calendarType = _state2.calendarType,
          calendarMonth = _state2.calendarMonth,
          calendarYear = _state2.calendarYear;


      if (calendarType === _constants.DAYS_CALENDAR) {
        this.setState({
          calendarMonth: calendarMonth === 0 ? _constants.DECEMBER_MONTH_INDEX : calendarMonth - 1,
          calendarYear: calendarMonth === 0 ? calendarYear - 1 : calendarYear
        });
      }

      if (calendarType === _constants.MONTHS_CALENDAR) {
        this.setState({ calendarYear: this.state.calendarYear - 1 });
      }
    }
  }, {
    key: 'handleEndNavigationClick',
    value: function handleEndNavigationClick() {
      var _state3 = this.state,
          calendarType = _state3.calendarType,
          calendarMonth = _state3.calendarMonth,
          calendarYear = _state3.calendarYear;


      if (calendarType === _constants.DAYS_CALENDAR) {
        this.setState({
          calendarMonth: calendarMonth === _constants.DECEMBER_MONTH_INDEX ? 0 : calendarMonth + 1,
          calendarYear: calendarMonth === _constants.DECEMBER_MONTH_INDEX ? calendarYear + 1 : calendarYear
        });
      }

      if (calendarType === _constants.MONTHS_CALENDAR) {
        this.setState({ calendarYear: calendarYear + 1 });
      }
    }
  }, {
    key: 'handleDateSelection',
    value: function handleDateSelection(_ref) {
      var year = _ref.year,
          month = _ref.month,
          day = _ref.day,
          hour = _ref.hour,
          minute = _ref.minute,
          rest = _objectWithoutProperties(_ref, ['year', 'month', 'day', 'hour', 'minute']);

      var selectedDate = new Date(this.state.selectedDate);
      var selectedYear = year !== undefined ? year : selectedDate.getFullYear();
      var selectedMonth = month !== undefined ? month : selectedDate.getMonth();
      var selectedDay = day !== undefined ? day : selectedDate.getDate();
      var selectedHour = hour !== undefined ? hour : selectedDate.getHours();
      var selectedMinute = minute !== undefined ? minute : selectedDate.getMinutes();
      var lastDayInSelectedMonth = new Date(selectedYear, selectedMonth + 1, 0).getDate();

      if (selectedDay > lastDayInSelectedMonth) {
        selectedDay = lastDayInSelectedMonth;
      }

      this.setState(_extends({
        selectedDate: +new Date(selectedYear, selectedMonth, selectedDay, selectedHour, selectedMinute)
      }, rest));
    }
  }, {
    key: 'handleDateChange',
    value: function handleDateChange() {
      var onChange = this.props.onChange;
      var selectedDate = this.state.selectedDate;

      var utcDate = this.getUTCFormatterDate(selectedDate);

      this.setState({ inputValue: selectedDate, triggerDialogClose: true }, function () {
        return onChange(utcDate);
      });
    }
  }, {
    key: 'resetSelectedDate',
    value: function resetSelectedDate() {
      var currentDate = new Date();
      currentDate.setHours(0);
      currentDate.setMinutes(0);
      currentDate.setSeconds(0);

      this.setState({
        calendarMonth: currentDate.getMonth(),
        calendarYear: currentDate.getFullYear(),
        selectedMinute: currentDate.getMinutes(),
        selectedHour: currentDate.getHours(),
        selectedDay: currentDate.getDate(),
        selectedMonth: currentDate.getMonth(),
        selectedYear: currentDate.getFullYear(),
        selectedDate: currentDate
      });
    }
  }, {
    key: 'renderCalendarNavigation',
    value: function renderCalendarNavigation() {
      var _this3 = this;

      var _state4 = this.state,
          calendarType = _state4.calendarType,
          calendarMonth = _state4.calendarMonth,
          calendarYear = _state4.calendarYear;
      var _props3 = this.props,
          translation = _props3.translation,
          disableDayPicker = _props3.disableDayPicker;


      var monthClasses = (0, _classnames2.default)('date-picker__nav-label', disableDayPicker && 'date-picker__nav-label--disabled');

      return _react2.default.createElement(
        'nav',
        { className: 'date-picker__nav' },
        _react2.default.createElement(_iconButton2.default, { icon: 'arrow-left-thin', shape: 'circle', onClick: this.handleStartNavigationClick }),
        calendarType !== _constants.MONTHS_CALENDAR && _react2.default.createElement(
          'span',
          { className: monthClasses, onClick: function onClick() {
              return _this3.setState({ calendarType: _constants.MONTHS_CALENDAR });
            } },
          translation.monthsName[calendarMonth]
        ),
        _react2.default.createElement(
          'span',
          { className: 'date-picker__nav-label', onClick: function onClick() {
              return _this3.setState({ calendarType: _constants.YEARS_CALENDAR });
            } },
          calendarYear
        ),
        _react2.default.createElement(_iconButton2.default, { icon: 'arrow-right-thin', shape: 'circle', onClick: this.handleEndNavigationClick })
      );
    }
  }, {
    key: 'renderDayEntity',
    value: function renderDayEntity(dateToRender, index) {
      var _this4 = this;

      var selectedDate = this.state.selectedDate;
      var _props4 = this.props,
          shouldDisableDate = _props4.shouldDisableDate,
          locales = _props4.locales;


      if (!dateToRender) {
        return _react2.default.createElement('div', { key: index, className: 'date-picker-calendar__entity date-picker-calendar__entity--disabled' });
      }

      var date = new Date(dateToRender);
      var intlCurrentDate = new Intl.DateTimeFormat(locales).format(new Date());
      var intlSelectedDate = new Intl.DateTimeFormat(locales).format(selectedDate);
      var intlDateToRender = new Intl.DateTimeFormat(locales).format(date);

      var isCurrentDay = intlDateToRender === intlCurrentDate;
      var isActive = intlDateToRender === intlSelectedDate;

      var classes = (0, _classnames2.default)('date-picker-calendar__entity', intlCurrentDate && shouldDisableDate(this.getUTCFormatterDate(date)) && 'date-picker-calendar__entity--disabled', isCurrentDay && 'date-picker-calendar__entity--current', isActive && 'date-picker-calendar__entity--selected');

      return _react2.default.createElement(
        'div',
        {
          key: index,
          className: classes,
          onClick: function onClick() {
            return _this4.handleDateSelection({
              day: date.getDate(),
              month: date.getMonth(),
              year: date.getFullYear()
            });
          }
        },
        date.getDate()
      );
    }
  }, {
    key: 'renderDaysCalendar',
    value: function renderDaysCalendar() {
      var _this5 = this;

      var abbreviatedDaysNames = this.props.translation.abbreviatedDaysNames;
      var startingDayIndex = this.getStartingWeekDayIndex();
      var dayNames = [].concat(abbreviatedDaysNames.slice(startingDayIndex, 7)).concat(abbreviatedDaysNames.slice(0, startingDayIndex));

      return _react2.default.createElement(
        'div',
        { className: 'date-picker__content date-picker__content--grid-view date-picker__content--fixed-height' },
        this.renderCalendarNavigation(),
        _react2.default.createElement(
          'div',
          { className: 'date-picker-calendar__row' },
          dayNames.map(function (day, index) {
            return _react2.default.createElement(
              'div',
              {
                key: index,
                className: 'date-picker-calendar__entity date-picker-calendar__entity--non-selectable'
              },
              day
            );
          })
        ),
        this.getWeeksInMonth().map(function (days, index) {
          return _react2.default.createElement(
            'div',
            { key: index, className: 'date-picker-calendar__row' },
            days.map(_this5.renderDayEntity)
          );
        })
      );
    }
  }, {
    key: 'renderMonthEntity',
    value: function renderMonthEntity(month, monthIndex) {
      var _this6 = this;

      var _state5 = this.state,
          currentMonth = _state5.currentMonth,
          currentYear = _state5.currentYear,
          calendarYear = _state5.calendarYear;
      var shouldDisableMonth = this.props.shouldDisableMonth;

      var isCurrentMonth = monthIndex === currentMonth && currentYear === calendarYear;
      var isActive = this.getSelectedMonth() === monthIndex && this.getSelectedYear() === calendarYear;
      var allMonthsDates = (0, _dateUtils.getDaysDatesInMonth)(monthIndex, calendarYear);

      var classes = (0, _classnames2.default)('date-picker-calendar__entity', isCurrentMonth && 'date-picker-calendar__entity--current', shouldDisableMonth(allMonthsDates) && 'date-picker-calendar__entity--disabled', isActive && 'date-picker-calendar__entity--selected');

      return _react2.default.createElement(
        'div',
        {
          key: monthIndex,
          className: classes,
          onClick: function onClick() {
            _this6.handleDateSelection({
              month: monthIndex,
              year: calendarYear,
              calendarType: _this6.state.defaultType,
              calendarMonth: monthIndex
            });
          }
        },
        month
      );
    }
  }, {
    key: 'renderMonthsCalendar',
    value: function renderMonthsCalendar() {
      var _this7 = this;

      var abbreviatedMonthsNames = this.props.translation.abbreviatedMonthsNames;
      var months = (0, _reduceToChunks2.default)(abbreviatedMonthsNames, 3);

      return _react2.default.createElement(
        'div',
        { className: 'date-picker__content date-picker__content--grid-view date-picker__content--fixed-height' },
        this.renderCalendarNavigation(),
        months.map(function (chunk, index) {
          return _react2.default.createElement(
            'div',
            { key: index, className: 'date-picker-calendar__row date-picker__calendar__row--month' },
            chunk.map(function (month, indexInChunk) {
              var monthIndex = index * chunk.length + indexInChunk;

              return _this7.renderMonthEntity(month, monthIndex);
            })
          );
        })
      );
    }
  }, {
    key: 'renderYearsCalendar',
    value: function renderYearsCalendar() {
      var _this8 = this;

      var selectedYear = this.getSelectedYear();
      var startYear = selectedYear - 50;
      var endYear = selectedYear + 51;
      var years = new Array(endYear - startYear).fill(null).map(function (e, i) {
        return startYear + i;
      });

      return _react2.default.createElement(
        'div',
        { className: 'date-picker__content date-picker__content--scrollable date-picker__content--fixed-height' },
        years.map(function (year) {
          var isSelected = selectedYear === year;
          var classes = (0, _classnames2.default)('date-picker-year-entity', isSelected && 'date-picker-year-entity--selected');

          return _react2.default.createElement(
            'span',
            {
              key: year,
              ref: function ref(_ref2) {
                return isSelected && (0, _scrollToElement2.default)(_ref2, { block: 'center', behavior: 'instant' });
              }
            },
            _react2.default.createElement(
              _text2.default,
              {
                className: classes,
                color: 'dark',
                weight: 'bold',
                onClick: function onClick() {
                  _this8.handleDateSelection({
                    year: year,
                    calendarType: _this8.state.defaultType,
                    calendarYear: year
                  });
                }
              },
              year
            )
          );
        })
      );
    }
  }, {
    key: 'renderFooter',
    value: function renderFooter() {
      var translation = this.props.translation;
      var shouldDisableDate = this.props.shouldDisableDate;
      var selectedDate = this.state.selectedDate;

      var shouldDisableSubmitButton = shouldDisableDate(this.getUTCFormatterDate(selectedDate));

      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
          _button2.default,
          { style: { marginLeft: 'auto' }, onClick: this.closeDatePicker },
          translation.cancelButton
        ),
        _react2.default.createElement(
          _button2.default,
          {
            color: 'primary',
            disabled: shouldDisableSubmitButton,
            onClick: this.handleDateChange
          },
          translation.okButton
        )
      );
    }
  }, {
    key: 'renderInput',
    value: function renderInput() {
      var inputValue = this.state.inputValue;
      var _props5 = this.props,
          disabled = _props5.disabled,
          renderInputDateValue = _props5.renderInputDateValue;


      var inputProps = {
        label: this.props.label,
        placeholder: this.props.placeholder,
        size: this.props.size,
        validationMessage: this.props.validationMessage,
        validationMessageTemplate: this.props.validationMessageTemplate,
        state: this.props.state,
        'data-e2e': 'date-picker'
      };

      if (disabled) {
        inputProps.disabled = disabled;
      }

      var dateToRender = '';

      if (inputValue) {
        if (renderInputDateValue) {
          dateToRender = renderInputDateValue(inputValue);
        } else {
          dateToRender = this.getInputDateFromLocales();
        }
      }

      var classes = (0, _classnames2.default)('date-picker-input', disabled && 'date-picker-input--disabled');

      return _react2.default.createElement(_input2.default, _extends({
        className: classes,
        value: dateToRender,
        readOnly: true,
        prefix: _react2.default.createElement(_icon2.default, { name: 'generic-calendar', size: '18', className: 'date-picker-calendar-icon' }),
        onClick: this.openDatePicker
      }, inputProps));
    }
  }, {
    key: 'renderDatePickerHeader',
    value: function renderDatePickerHeader() {
      var calendarType = this.state.calendarType;
      var _props6 = this.props,
          disableTodayButton = _props6.disableTodayButton,
          translation = _props6.translation;

      var shouldRenderTodayButton = !disableTodayButton && calendarType === _constants.DAYS_CALENDAR;

      return _react2.default.createElement(
        _toolbar2.default,
        { className: 'date-picker__header', align: 'center', justify: 'space-between', density: 'comfortable' },
        _react2.default.createElement(
          _title2.default,
          { level: '3', color: 'light', density: 'cozy', weight: 'medium' },
          this.getHeaderDateFromLocales()
        ),
        shouldRenderTodayButton && _react2.default.createElement(
          _button2.default,
          { type: 'link', color: 'secondary', onClick: this.resetSelectedDate },
          translation.todayButton
        )
      );
    }
  }, {
    key: 'renderDatePickerDialog',
    value: function renderDatePickerDialog() {
      var _state6 = this.state,
          calendarType = _state6.calendarType,
          isDatePickerVisible = _state6.isDatePickerVisible,
          triggerDialogClose = _state6.triggerDialogClose;
      var className = this.props.className;


      if (!isDatePickerVisible && !triggerDialogClose) {
        return null;
      }

      var classes = (0, _classnames2.default)('date-picker', className);

      return _react2.default.createElement(
        _dialog2.default,
        {
          className: classes,
          density: 'none',
          size: 'small',
          triggerClose: triggerDialogClose,
          footer: this.renderFooter(),
          onCloseHandler: this.closeDatePicker,
          renderCustomHeader: this.renderDatePickerHeader
        },
        calendarType === _constants.DAYS_CALENDAR && this.renderDaysCalendar(),
        calendarType === _constants.MONTHS_CALENDAR && this.renderMonthsCalendar(),
        calendarType === _constants.YEARS_CALENDAR && this.renderYearsCalendar()
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        this.renderInput(),
        this.renderDatePickerDialog()
      );
    }
  }]);

  return DatePicker;
}(_react2.default.Component);

DatePicker.propTypes = {
  className: _propTypes2.default.string,

  // Input
  // TODO export
  label: _propTypes2.default.string,
  placeholder: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['small', 'medium', 'large', 'x-large']),
  validationMessage: _propTypes2.default.string,
  validationMessageTemplate: _propTypes2.default.func,
  state: _propTypes2.default.oneOf(['success', 'error', 'warning', 'hint']),
  disabled: _propTypes2.default.bool,
  renderInputDateValue: _propTypes2.default.func,

  // DatePicker
  disableDayPicker: _propTypes2.default.bool,
  disableTodayButton: _propTypes2.default.bool,
  hideDayInHeader: _propTypes2.default.bool,
  locales: _propTypes2.default.string,
  shouldDisableDate: _propTypes2.default.func,
  shouldDisableMonth: _propTypes2.default.func,
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  onChange: _propTypes2.default.func,
  translation: _propTypes2.default.object
};

DatePicker.defaultProps = {
  disableDayPicker: false,
  disableTodayButton: false,
  hideDayInHeader: false,
  placeholder: 'Select a date',
  locales: navigator.language || 'en-US',
  shouldDisableDate: function shouldDisableDate() {
    return false;
  },
  shouldDisableMonth: function shouldDisableMonth() {
    return false;
  },
  onChange: function onChange(date) {
    return date;
  },

  translation: {
    backButton: 'Back',
    cancelButton: 'Cancel',
    okButton: 'Ok',
    todayButton: 'Today',
    abbreviatedDaysNames: _constants.ABBREVIATED_DAYS,
    abbreviatedMonthsNames: _constants.ABBREVIATED_MONTHS,
    monthsName: _constants.FULL_MONTHS_NAMES
  }
};

exports.default = DatePicker;